/* Newsletter handler with WhatsApp fallback
   - Intercepts submit on forms with data-newsletter-form
   - Tries Shopify /contact first (creates customer with newsletter tag)
   - If 400 (CAPTCHA missing / spam protection), falls back to WhatsApp deep link
     so the user can complete the subscription via WhatsApp message to the shop.
   - Shows inline feedback (no page reload).
*/
(function(){
  'use strict';

  var WHATSAPP_NUMBER = '393385683268'; // ilgiardinodelreshop.it WhatsApp
  var STORAGE_KEY = 'gdr_newsletter_subs';

  function saveLocal(email){
    try{
      var subs = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (subs.indexOf(email) === -1) subs.push(email);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(subs));
    } catch(e){}
  }

  function feedback(form, msg, kind){
    var fb = form.querySelector('[data-newsletter-feedback]');
    if (!fb) {
      fb = document.createElement('p');
      fb.setAttribute('data-newsletter-feedback','');
      fb.style.cssText = 'margin-top:10px;font-size:14px';
      form.appendChild(fb);
    }
    fb.style.display = 'block';
    fb.style.color = kind === 'success' ? '#1a7f37' : kind === 'warn' ? '#9a6700' : '#cf222e';
    fb.innerHTML = msg;
  }

  function whatsappFallback(form, email){
    var text = encodeURIComponent('Ciao! Vorrei iscrivermi alla newsletter. La mia email è: ' + email);
    var url = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + text;
    feedback(form,
      '✓ Quasi fatto! Conferma su WhatsApp per ricevere offerte esclusive — ' +
      '<a href="'+ url +'" target="_blank" rel="noopener" style="text-decoration:underline;font-weight:600">Apri WhatsApp</a>',
      'success');
    // Auto-open whatsapp on user gesture (was a submit click)
    var w = window.open(url, '_blank', 'noopener');
    if (!w) {
      // Popup blocked — user clicks the inline link instead
    }
  }

  function handleSubmit(e){
    var form = e.target;
    if (!form.matches('form[data-newsletter-form]')) return;
    e.preventDefault();

    var emailEl = form.querySelector('[data-newsletter-email]');
    var btn = form.querySelector('[data-newsletter-submit]');
    var email = (emailEl && emailEl.value || '').trim();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)){
      feedback(form, 'Inserisci un indirizzo email valido.', 'error');
      return;
    }

    if (btn) { btn.disabled = true; btn.dataset._txt = btn.textContent; btn.textContent = 'Invio…'; }
    feedback(form, 'Attendi…', 'warn');

    // Try Shopify /contact (form_type=customer)
    var fd = new FormData(form);
    fetch(form.action, {
      method: 'POST',
      body: fd,
      credentials: 'include',
      headers: { 'Accept': 'text/html' }
    }).then(function(r){
      saveLocal(email);
      if (r.status === 200 || r.redirected) {
        // success or redirect to confirmation page
        feedback(form,
          '🎉 Iscrizione ricevuta! Ti contatteremo presto con le nostre offerte esclusive.',
          'success');
        if (emailEl) emailEl.value = '';
      } else {
        // 400 etc. (CAPTCHA blocked or other) → WhatsApp fallback
        whatsappFallback(form, email);
      }
    }).catch(function(){
      whatsappFallback(form, email);
    }).finally(function(){
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset._txt || 'Iscriviti'; }
    });
  }

  document.addEventListener('submit', handleSubmit, true);
})();
